export const TIMEOUT = 250;

export const BREAKPOINTS = {
  DESKTOP: 992,
  TABLET: 768,
  PHONE: 376,
};

export const COLORS = {
  grayVLight: '#fafafa',
  grayLight: '#e3e3e3',
  grayMedium: '#c7c7c7',
  gray: '#c8c9c7',
  disabled: '#999',
  grayDark: '#666',
  grayDarker: '#333',
  white: '#fff',
  black: '#000',
  danger: '#ef5350',
  warning: '#fdc02f',
  success: '#8bc34a',
  info: '#00b6ed',
  bodyBg: 'white',
  textError: '#ef5350',
  cart: '#ee6881',
  cartHover: '#f4a33f',
};

export const TYPOGRAPHY = {
  fontFamilyBase:
    'Arial, Calibri, nimbussansl, liberationsans, freesans, clean, sans-serif',
  fontFamilyHeadings: 'Roboto Condensed,Calibri,Arial,sans-serif',
  fontSizeExtraSmall: '0.75rem', // 12px
  fontSizeSmall: '0.857rem', // 14px
  fontSizeBase: '16px',
  fontSize: '1rem', // 16px
  fontSizeMedium: '1.125rem', // 18px
  fontSizeLarge: '1.4375rem', // 23px
  fontSizeExtraLarge: '3.125rem', // 50px
  fontWeightHeavy: '700',
  fontWeightMedium: '400', // default
  fontWeightLight: '300',
  fontWeightVLight: '100',
  headingExtraLarge: '2rem', // 32px
  headingLarge: '1.4375rem', // 23px
  headingMedium: '1.1875rem', // 19px
  headingBase: '1rem', // 16px
  headingSmall: '0.875rem', // 14px
  headingExtraSmall: '0.75rem', // 12px
};

export const UTILITIES = {
  borderRadius: '3px',
  borderColor: COLORS.gray,
  lineHeight: '1.5',
  lineHeightLarge: '2',
  rhythmBase: '16px',
  rhythmVerticalBase: '16px',
  rhythmHorizontalBase: '16px',
  contentMaxWidth: '1020px',
  spacingBase: '8px',
  spacingUnit: '8',
};
